import React, { useState, useMemo } from 'react'
import { Card } from '../../components/common'
import TabsView from 'app-components/general/TabsViews'
import JobSummary from 'app-components/run-in-hole/job-summary/JobSummary'
import Documents from 'app-components/general/documents/Documents'
import PipeLists from 'app-components/run-in-hole/pipe-lists/PipeLists'
import DescentChart from './descent-chart/DescentChart'

import styled from 'styled-components'
import { useTranslation } from 'react-i18next'

const runInRoleSource = "RUN_IN_ROLE"

const CardWrap = styled(Card)`
    flex-wrap: wrap;
`
const RunInHole = () => {
    const [currentInnerTab, setCurrentInnerTab] = useState(0)
    const { t } = useTranslation()

    const innerTabs = useMemo(() => [
        {
            title: t('job summary'),
            content: <JobSummary />
        },
        {
            title: t('chart'),
            content: <DescentChart />
        },
        {
            title: t('pipe lists'),
            content: <PipeLists />
        },
        {
            title: t('documents'),
            content: <Documents src={runInRoleSource} />
        }
    ], [t])


    return (
        <CardWrap backgroundColor="background" padding="0px" margin="0px 0px 20px 0px" alignSelf="stretch">
            <TabsView selectedIndex={currentInnerTab} onSelect={setCurrentInnerTab} data={innerTabs} subtab="true" />
        </CardWrap>
    )
}


export default RunInHole